
(function () {
  if (window.__z9PdpAnimInit) return;
  window.__z9PdpAnimInit = true;

  function init() {
    var targets = document.querySelectorAll('[data-z9-anim]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('z9-in-view'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('z9-in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  function deferred() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 1500 });
    } else {
      setTimeout(init, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferred);
  } else {
    deferred();
  }

  
  document.addEventListener('shopify:section:load', init);
})();
